import { useEffect, useState } from 'react'
import { useAuthStore } from '../data/useAuthStore'
import { getUserAvatarUrl } from '../api/users'

interface IUserAvatarProps {
  onClick?: () => void
  className?: string
}

export const UserAvatar = (props: IUserAvatarProps) => {
  const { user, userProfile } = useAuthStore()
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null)

  useEffect(() => {
    getAvatarUrl()
  }, [user])

  const getInitial = () => {
    if (user?.email) {
      return user.email.charAt(0).toUpperCase()
    }
    return 'U'
  }

  const getBackgroundColor = () => {
    // Generate a consistent color based on email
    if (user?.email) {
      const colors = [
        'bg-blue-500',
        'bg-green-500',
        'bg-purple-500',
        'bg-pink-500',
        'bg-indigo-500',
        'bg-red-500',
        'bg-yellow-500',
        'bg-teal-500',
      ]
      const index = user.email.charCodeAt(0) % colors.length
      return colors[index]
    }
    return 'bg-gray-500'
  }

  const getAvatarUrl = async () => {
    if (userProfile?.avatar && userProfile?.id) {
      const file = getUserAvatarUrl({ id: userProfile.id, avatar: userProfile.avatar })
      setAvatarUrl(file)
    }
  }

  return (
    <button
      onClick={props.onClick}
      className={
        props.className ||
        `w-10 h-10 rounded-full ${getBackgroundColor()} cursor-pointer flex items-center justify-center text-white font-semibold hover:opacity-80 transition-opacity overflow-hidden`
      }
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="User avatar" className="w-full h-full object-cover" />
      ) : (
        getInitial()
      )}
    </button>
  )
}
